export const INITIAL_CLINICIAN_NOTES_SCHEMA = [
  {
    elementConfig: {
      label: "1. Please describe your difficulties:",
      placeholder: "Please describe your difficulties",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_description",
  },
  {
    elementConfig: {
      label: "2. When did these difficulties begin?",
      placeholder: "When did these difficulties begin?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_start",
  },
  {
    elementConfig: {
      label: "3. How did these difficulties begin or what caused these difficulties?",
      placeholder: "How did these difficulties begin or what caused these difficulties?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_causation",
  },
  {
    elementConfig: {
      label: "4. How have these difficulties changed over time?",
      placeholder: "How have these difficulties changed over time?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_change",
  },
  {
    elementConfig: {
      label: "5. How have these difficulties impact in your life?",
      placeholder: "How have these difficulties impact in your life?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_impact",
  },
  {
    elementConfig: {
      label: "6. How have these difficulties affected others?",
      placeholder: "How have these difficulties affected others?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_affect_others",
  },
  {
    elementConfig: {
      label:
        "7. Have you tried to solve these difficulties (e.g. Past solutions, treatment, etc.)?",
      placeholder:
        "Have you tried to solve these difficulties (e.g. Past solutions, treatment, etc.)?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "past_solutions",
  },
  {
    elementConfig: {
      label: "8. Which past solutions have worked and why?",
      placeholder: "Which past solutions have worked and why?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "past_solutions_success",
  },
  {
    elementConfig: {
      label: "9. Which past solutions did not work and why?",
      placeholder: "Which past solutions did not work and why?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "past_solutions_fail",
  },
  {
    elementConfig: {
      label: "10. Are you motivated to solve these problems now?",
      placeholder: "Are you motivated to solve these problems now?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "motivation_to_solve",
  },
  {
    elementConfig: {
      label: "11. What do you need to solve these problems?",
      placeholder: "What do you need to solve these problems?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "solution_requirements",
  },
  {
    elementConfig: {
      label:
        "12. If we were successful, what changes would you make or how would your life be different?",
      placeholder:
        "If we were successful, what changes would you make or how would your life be different?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "post_success_changes",
  },
  {
    elementConfig: {
      label: "13. Current medications?",
      placeholder: "Current medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "current_medications",
  },
  {
    elementConfig: {
      label: "14. How long have you been taking these medications?",
      placeholder: "How long have you been taking these medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "medication_duration",
  },
  {
    elementConfig: {
      label: "15. Have these medications been helpful?",
      placeholder: "Have these medications been helpful?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "medication_success",
  },
  {
    elementConfig: {
      label: "16. Any side effects of current medications?",
      placeholder: "Any side effects of current medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "medication_side_effects",
  },
  {
    elementConfig: {
      label: "17. What medications have you taken in the past?",
      placeholder: "What medications have you taken in the past?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "past_medications",
  },
  {
    elementConfig: {
      label: "18. How do you feel about current medications compared to past medications?",
      placeholder: "How do you feel about current medications compared to past medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "current_past_comparison",
  },
  {
    elementConfig: {
      label: "19. How do you feel about current medications compared to no medications?",
      placeholder: "How do you feel about current medications compared to no medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "current_no_comparison",
  },
  {
    elementConfig: {
      label: "20. Additional Information",
      placeholder: "Additional Information",
      type: "textArea",
    },
    elementType: "textarea",
    name: "additional_info",
  },
];

export const OUTCOME_CLINICIAN_NOTES_SCHEMA = [
  {
    elementConfig: {
      label: "1. Please describe your difficulties today.",
      placeholder: "Please describe your difficulties today.",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_description",
  },
  {
    elementConfig: {
      label: "2. How have your difficulties changed from 3 months ago?",
      placeholder: "How have your difficulties changed from 3 months ago?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_change",
  },
  {
    elementConfig: {
      label: "3. What is the impact of your current difficulties?",
      placeholder: "What is the impact of your current difficulties?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_impact",
  },
  {
    elementConfig: {
      label: "4. How do you cope with these difficulties today versus 3 months ago?",
      placeholder: "How do you cope with these difficulties today versus 3 months ago?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "difficulties_cope",
  },
  {
    elementConfig: {
      label: "5. What improvements have you made in the last 3 months?",
      placeholder: "What improvements have you made in the last 3 months?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "solution_change",
  },
  {
    elementConfig: {
      label: "6. How have you achieved these improvements?",
      placeholder: "How have you achieved these improvements?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "solution_how",
  },
  {
    elementConfig: {
      label: "7. How do these improvements impact your life and relationships?",
      placeholder: "How do these improvements impact your life and relationships?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "solution_affect_others",
  },
  {
    elementConfig: {
      label: "8. How motivated are you to continue improving your life?",
      placeholder: "How motivated are you to continue improving your life?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "motivation_to_solve",
  },
  {
    elementConfig: {
      label: "9. What support do you need to continue to improve your life?",
      placeholder: "What support do you need to continue to improve your life?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "solution_support",
  },
  {
    elementConfig: {
      label: "10. How will your life be different if you continue to improve?",
      placeholder: "How will your life be different if you continue to improve?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "solution_continue",
  },
  {
    elementConfig: {
      label: "11. If applicable, what are your current medications?",
      placeholder: "If applicable, what are your current medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "current_medications",
  },
  {
    elementConfig: {
      label: "12. Are these medications helpful?",
      placeholder: "Are these medications helpful?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "medication_success",
  },
  {
    elementConfig: {
      label: "13. Any side effects of current medications?",
      placeholder: "Any side effects of current medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "medication_side_effects",
  },
  {
    elementConfig: {
      label:
        "14. How do current medications compare to past medications so do they compare or no medications?",
      placeholder:
        "How do current medications compare to past medications so do they compare or no medications?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "current_past_comparison",
  },
  {
    elementConfig: {
      label: "15. What do you what do you think your medications will look like in the future?",
      placeholder: "What do you what do you think your medications will look like in the future?",
      type: "textArea",
    },
    elementType: "textarea",
    name: "medication_future",
  },
  {
    elementConfig: {
      label: "16. Additional Information",
      placeholder: "Additional Information",
      type: "textArea",
    },
    elementType: "textarea",
    name: "additional_info",
  },
];

export const MENTAL_STATUS_QUESTIONS_SCHEMA = [
  {
    elementConfig: {
      label: "1. Body Type",
      options: [
        { display: "Thin", value: "thin" },
        { display: "Average", value: "average" },
        { display: "Overweight", value: "overweight" },
        { display: "Obese", value: "obese" },
      ],
    },
    elementType: "radio",
    name: "body_type",
  },
  {
    elementConfig: {
      label: "2. Height",
      options: [
        { display: "Short", value: "short" },
        { display: "Average", value: "average" },
        { display: "Tall", value: "tall" },
        { display: "Very Tall", value: "very_tall" },
      ],
    },
    elementType: "radio",
    name: "height",
  },
  {
    elementConfig: {
      label: "3. Consciousness",
      options: [
        { display: "Alert", value: "alert" },
        { display: "Sleepy", value: "sleepy" },
        { display: "Delirious", value: "delirious" },
        { display: "In a stupor", value: "in_a_stupor" },
      ],
    },
    elementType: "radio",
    name: "consciousness",
  },
  {
    elementConfig: {
      label: "4. Dress",
      options: [
        { display: "Inappropriately", value: "inappropriately" },
        { display: "Poorly", value: "poorly" },
        { display: "Casually", value: "casually" },
        { display: "Well-dressed", value: "well" },
      ],
    },
    elementType: "radio",
    name: "dress",
  },
  {
    elementConfig: {
      label: "5. Hygiene",
      options: [
        { display: "Disheveled", value: "disheveled" },
        { display: "Adequately groomed", value: "adequately_groomed" },
        { display: "Well groomed", value: "well_groomed" },
      ],
    },
    elementType: "radio",
    name: "hygiene",
  },
  {
    elementConfig: {
      label: "6. Appearance",
      options: [
        { display: "Stated Age", value: "stated_age" },
        { display: "Younger", value: "younger" },
        { display: "Older", value: "older" },
      ],
    },
    elementType: "radio",
    name: "appearance_1",
  },
  {
    elementConfig: {
      label: "7. Appearance",
      options: [
        { display: "Athletic", value: "athletic" },
        { display: "Healthy", value: "healthy" },
        { display: "Sickly", value: "sickly" },
        { display: "Frail", value: "frail" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "appearance_2",
  },
  {
    elementConfig: {
      label: "8. Speech Volume",
      options: [
        { display: "Whisper", value: "whisper" },
        { display: "Soft", value: "soft" },
        { display: "Normal", value: "normal" },
        { display: "Loud", value: "loud" },
      ],
    },
    elementType: "radio",
    name: "speech_volume",
  },
  {
    elementConfig: {
      label: "9. Speech Flow",
      options: [
        { display: "Slow / Delayed", value: "slow_delayed" },
        { display: "Hesitant", value: "hesitant" },
        { display: "Normal / Spontaneous", value: "normal_spontaneous" },
        { display: "Talkative", value: "talkative" },
      ],
    },
    elementType: "radio",
    name: "speech_flow",
  },
  {
    elementConfig: {
      label: "10. Speech Qualities",
      options: [
        { display: "Mumbling", value: "mumbling" },
        { display: "Slurring", value: "slurring" },
        { display: "Perseveration", value: "perseveration" },
        { display: "Stuttering", value: "stuttering" },
        { display: "Accent", value: "accent" },
        { display: "Lisp", value: "lisp" },
        { display: "Monotone", value: "monotone" },
        { display: "None of the above", value: "none" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "speech_qualities",
  },
  {
    elementConfig: {
      label: "11. Speech Content",
      options: [
        { display: "Word Salad", value: "word_salad" },
        { display: "Clanging", value: "clanging" },
        { display: "Punning", value: "punning" },
        { display: "Neologism", value: "neologism" },
        { display: "None of the above", value: "none" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "speech_content",
  },
  {
    elementConfig: {
      label: "12. Eye Contact",
      options: [
        { display: "Avoidant", value: "avoidant" },
        { display: "Intermittent", value: "intermittent" },
        { display: "Alomost constant", value: "almost_constant" },
        { display: "Appropriate eye contact", value: "appropriate" },
      ],
    },
    elementType: "radio",
    name: "eye_contact",
  },
  {
    elementConfig: {
      label: "13. Behavior Activity",
      options: [
        { display: "Slow", value: "slow" },
        { display: "Calm", value: "calm" },
        { display: "Tense", value: "tense" },
        { display: "Agitated", value: "agitated" },
      ],
    },
    elementType: "radio",
    name: "behavior_activity",
  },
  {
    elementConfig: {
      label: "14. Behavior Purpose",
      options: [
        { display: "Bizarre", value: "bizarre" },
        { display: "Aimless", value: "aimless" },
        { display: "Purposeful", value: "purposeful" },
      ],
    },
    elementType: "radio",
    name: "behavior_purpose",
  },
  {
    elementConfig: {
      label: "15. Behavioral Qualities",
      options: [
        { display: "Tics", value: "tics" },
        { display: "Twitches", value: "twitches" },
        { display: "Stereotypic Motions", value: "stereotypic_motions" },
        { display: "None of the above", value: "none" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "behavioral_qualities",
  },
  {
    elementConfig: {
      label: "16. Relationship to Interviewer",
      options: [
        { display: "Threatening", value: "threatening" },
        { display: "Argumentative", value: "argumentative" },
        { display: "Defensive", value: "defensive" },
        { display: "Evasive", value: "evasive" },
        { display: "Apathetic", value: "apathetic" },
        { display: "Cooperative", value: "cooperative" },
        { display: "Friendly", value: "friendly" },
        { display: "Interested", value: "interested" },
        { display: "Ingratiating", value: "ingratiating" },
        { display: "Seductive", value: "seductive" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "relationship_to_interviewer",
  },
  {
    elementConfig: {
      label: "17. Level of Rapport",
      options: [
        { display: "Minimal", value: "minimal" },
        { display: "Adequate", value: "adequate" },
        { display: "Good", value: "good" },
      ],
    },
    elementType: "radio",
    name: "level_of_rapport",
  },
  {
    elementConfig: {
      label: "18. Thought Process",
      options: [
        { display: "Thought Blocking", value: "thought_blocking" },
        { display: "Limited (poverty)", value: "limited" },
        { display: "Loose", value: "loose" },
        { display: "Circumstantial", value: "circumstantial" },
        { display: "Tangential", value: "tangential" },
        { display: "Flight of ideas", value: "flight_of_ideas" },
        { display: "Logical", value: "logical" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "thought_process",
  },
  {
    elementConfig: {
      label: "19. Quality of Thoughts",
      options: [
        { display: "Paranoid", value: "paranoid" },
        { display: "Fearful", value: "fearful" },
        { display: "Suspicious", value: "suspicious" },
        { display: "Grandiose", value: "grandiose" },
        { display: "Obsessional", value: "obsessional" },
        { display: "Hypochondriacal", value: "hypochondriacal" },
        { display: "Negativistic", value: "negativistic" },
        { display: "Depressed", value: "depressed" },
        { display: "Magical", value: "magical" },
        { display: "Appropriate", value: "appropriate" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "quality_of_thoughts",
  },
  {
    elementConfig: {
      label: "20. Hallucinations",
      options: [
        { display: "No hallucinations", value: "no_hallucinations" },
        { display: "Auditory", value: "auditory" },
        { display: "Command", value: "command" },
        { display: "Visual", value: "visual" },
        { display: "Tactile", value: "tactile" },
        { display: "Olfactory", value: "olfactory" },
        { display: "Gustatory", value: "gustatory" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "hallucinations",
  },
  {
    elementConfig: {
      label: "21. Delusions",
      options: [
        { display: "No delusions", value: "no_delusions" },
        { display: "Grandeur", value: "grandeur" },
        { display: "Persecution", value: "persecution" },
        { display: "Somatic", value: "somatic" },
        { display: "Jealousy", value: "jealousy" },
        { display: "Love", value: "love" },
        { display: "Guilt", value: "guilt" },
        { display: "Ideas of reference", value: "ideas_of_reference" },
        { display: "Ideas of influence", value: "ideas_of_influence" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "delusions",
  },
  {
    elementConfig: {
      label: "22. Perceptual Distortions",
      options: [
        { display: "Depersonalization", value: "depersonalization" },
        { display: "Derealization", value: "derealization" },
        { display: "Disassociation", value: "disassociation" },
        { display: "None of the above", value: "none" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "perceptual_distortions",
  },
  {
    elementConfig: {
      label: "23. Affect",
      options: [
        { display: "Flat", value: "flat" },
        { display: "Blunted", value: "blunted" },
        { display: "Restricted", value: "restricted" },
        { display: "Broad", value: "broad" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "affect1",
  },
  {
    elementConfig: {
      label: "24. Affect",
      options: [
        { display: "Appropriate", value: "appropriate" },
        { display: "Inappropriate", value: "inappropriate" },
      ],
    },
    elementType: "radio",
    name: "affect2",
  },
  {
    elementConfig: {
      label: "25. Mood",
      options: [
        { display: "Expansive", value: "expansive" },
        { display: "Euphoric", value: "euphoric" },
        { display: "Euthymic", value: "euthymic" },
        { display: "Dysphoric", value: "dysphoric" },
        { display: "Irritable", value: "irritable" },
        { display: "Anxious", value: "anxious" },
        { display: "Guilty", value: "guilty" },
        { display: "Grief-stricken", value: "grief_stricken" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "mood",
  },
  {
    elementConfig: {
      label: "26. Orientation",
      options: [
        { display: "Not oriented to person", value: "not_oriented_to_person" },
        { display: "Not oriented to place", value: "not_oriented_to_place" },
        { display: "Not oriented to time", value: "not_oriented_to_time" },
        { display: "Oriented X 3", value: "all" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "orientation",
  },
  {
    elementConfig: {
      label: "27. Level of Intelligence",
      options: [
        { display: "Retarded", value: "retarded" },
        { display: "Below average", value: "below_average" },
        { display: "Average", value: "average" },
        { display: "Above average", value: "above_average" },
      ],
    },
    elementType: "radio",
    name: "level_of_intelligence1",
  },
  {
    elementConfig: {
      label: "28. Level of Intelligence",
      options: [
        { display: "With abstract thinking", value: "with_abstract_thinking" },
        { display: "Without abstract thinking", value: "without_abstract_thinking" },
      ],
    },
    elementType: "radio",
    name: "level_of_intelligence2",
  },
  {
    elementConfig: {
      label: "29. Concentration",
      options: [
        { display: "Intact", value: "intact" },
        { display: "Mildly impaired", value: "mildly_impaired" },
        { display: "Moderately impaired", value: "moderately_impaired" },
        { display: "Severely impaired", value: "severely_impaired" },
      ],
    },
    elementType: "radio",
    name: "concentration",
  },
  {
    elementConfig: {
      label: "30. Memory",
      options: [
        { display: "No memory problems", value: "no_problems" },
        { display: "Immediate", value: "immediate" },
        { display: "Short-term", value: "short_term" },
        { display: "Long-term", value: "long_term" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "memory",
  },
  {
    elementConfig: {
      label: "31. Impulse Control",
      options: [
        { display: "Good", value: "good" },
        { display: "Fair", value: "fair" },
        { display: "Poor", value: "poor" },
        { display: "Impaired", value: "impaired" },
      ],
    },
    elementType: "radio",
    name: "impulse_control",
  },
  {
    elementConfig: {
      label: "32. Judgement",
      options: [
        { display: "Good", value: "good" },
        { display: "Fair", value: "fair" },
        { display: "Poor", value: "poor" },
        { display: "Impaired", value: "impaired" },
      ],
    },
    elementType: "radio",
    name: "judgement",
  },
  {
    elementConfig: {
      label: "33. Insight",
      options: [
        { display: "Good", value: "good" },
        { display: "Fair", value: "fair" },
        { display: "Poor", value: "poor" },
        { display: "Impaired", value: "impaired" },
      ],
    },
    elementType: "radio",
    name: "insight",
  },
  {
    elementConfig: {
      label: "34. Homicidal Risk",
      options: [
        { display: "Ideation", value: "ideation" },
        { display: "Plans or means", value: "plans_or_means" },
        { display: "Intent", value: "intent" },
        { display: "Recency or lethality", value: "recency_or_lethality" },
        { display: "History of violence", value: "history_of_violence" },
        { display: "Situational specificity", value: "situational_specificity" },
        { display: "Impulsivity", value: "impulsivity" },
        { display: "None of the above", value: "none" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "homicidal_risk",
  },
  {
    elementConfig: {
      label: "35. Suicidal Risk",
      options: [
        { display: "Ideation", value: "ideation" },
        { display: "Plans or means", value: "plans_or_means" },
        { display: "Intent", value: "intent" },
        { display: "Recency or lethality", value: "recency_or_lethality" },
        { display: "History of violence", value: "history_of_violence" },
        { display: "Situational specificity", value: "situational_specificity" },
        { display: "Impulsivity", value: "impulsivity" },
        { display: "None of the above", value: "none" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "suicidal_risk",
  },
  {
    elementConfig: {
      label: "36. Special Needs",
      options: [
        { display: "No special needs", value: "no_special_needs" },
        { display: "Ambulation", value: "ambulation" },
        { display: "Vision", value: "vision" },
        { display: "Hearing", value: "hearing" },
        { display: "Reading", value: "reading" },
        { display: "Writing", value: "writing" },
        { display: "Diet", value: "diet" },
        { display: "Language or communication", value: "language_or_communication" },
        { display: "Other health factors", value: "other" },
        { display: "None of the above", value: "none" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    name: "special_needs",
  },
];

export const INITIAL_CLINICAL_DIAGNOSIS_SCHEMA = [
  {
    elementConfig: {
      label: "Overall Assessment Impressions",
      placeholder: "Overall Assessment Impressions",
      type: "textArea",
    },
    elementType: "textarea",
    name: "overall_assessment_impressions",
  },
  {
    elementConfig: {
      label: "Diagnostic Impressions",
      placeholder: "Diagnostic Impressions",
      type: "textArea",
    },
    elementType: "textarea",
    name: "diagnostic_impressions",
  },
  {
    elementConfig: {
      label: "Recommendations",
      placeholder: "Recommendations",
      type: "textArea",
    },
    elementType: "textarea",
    name: "recommendations",
  },
  {
    elementConfig: {
      label: "Assessment Recommendation",
      options: [
        { display: "90 Day Care", value: "90_day_care" },
        { display: "No", value: "no" },
        { display: "CDPHP SPMI Contract", value: "cdphp_spmi_contract" },
        { display: "CDPHP Medication Only", value: "cdphp_medication_only" },
      ],
      placeholder: "Assessment Recommendation",
      sentenceCase: false,
    },
    elementType: "select",
    name: "enroll",
  },
  {
    elementConfig: {
      label: "ICD-10 Primary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_diagnosis_axis_1",
  },
  {
    elementConfig: {
      label: "ICD-10 Secondary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_diagnosis_axis_2",
  },
  {
    elementConfig: {
      label: "Link Call",
      options: [],
      placeholder: "",
    },
    elementType: "select",
    name: "call_id",
  },
  {
    elementConfig: {
      label: "Diagnostic Review",
      placeholder: "",
      type: "checkbox",
    },
    elementType: "checkbox",
    name: "additional_diagnostic_activities_placeholder",
  },
];

export const OUTCOME_CLINICAL_DIAGNOSIS_SCHEMA = [
  {
    elementConfig: {
      label: "Overall Assessment Impressions",
      placeholder: "Overall Assessment Impressions",
      type: "textArea",
    },
    elementType: "textarea",
    name: "overall_assessment_impressions",
  },
  {
    elementConfig: {
      label: "Diagnostic Impressions",
      placeholder: "Diagnostic Impressions",
      type: "textArea",
    },
    elementType: "textarea",
    name: "diagnostic_impressions",
  },
  {
    elementConfig: {
      label: "Recommendations",
      placeholder: "Recommendations",
      type: "textArea",
    },
    elementType: "textarea",
    name: "recommendations",
  },
  {
    elementConfig: {
      label: "Post 90-Day Assessment Outcome",
      options: [
        { label: "Return to PCP care", value: "Return to PCP care" },
        {
          label: "aptihealth Extended-Care for counseling",
          value: "aptihealth Extended-Care for counseling",
        },
        {
          label: "aptihealth Extended-Care for counseling & medication management",
          value: "aptihealth Extended-Care for counseling & medication management",
        },
      ],
      placeholder: "Post 90-Day Assessment Outcome",
    },
    elementType: "select",
    name: "pcp_consult_outcome",
  },
];
